import { EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface MarkerProps {
    text: string;
    category1: 'true' | 'false';
    category2: 'true' | 'false';
    category3: 'true' | 'false';
    category4: 'true' | 'false';
}

// 1. Økonomi, regnskap og revisjon
// 2. Markedsførign
// 3. Rettsvitenskap
// 4. Samfunnsvitenskap
// 5. Informasjonsteknologi
// 6. Andre studieretninger

export const markerRevolveVariables = [
    {
        variableName: 'text' as const,
        type: 'string' as const
    },
    {
        variableName: 'category1' as const,
        type: 'boolean' as const
    },
    {
        variableName: 'category2' as const,
        type: 'boolean' as const
    },
    {
        variableName: 'category3' as const,
        type: 'boolean' as const
    },
    {
        variableName: 'category4' as const,
        type: 'boolean' as const
    }
];

export const markerRevolve = (props: MarkerProps) => {
    const isInCategory1 = props.category1 === 'true';
    const isInCategory2 = props.category2 === 'true';
    const isInCategory3 = props.category3 === 'true';
    const isInCategory4 = props.category4 === 'true';

    const isInAnyCategory = isInCategory1 || isInCategory2 || isInCategory3 || isInCategory4;

    return (
        <S_Container>
            <S_Text>{props.text}</S_Text>
            {isInAnyCategory && (
                <S_Circle>
                    <S_InnerCircle>
                        {isInCategory1 && (
                            <S_Quarter
                                $background={
                                    'linear-gradient(131deg, rgb(170 25 30) 0%, rgb(253 93 98) 100%)'
                                }
                                $rotate={90}
                            />
                        )}
                        {isInCategory2 && (
                            <S_Quarter
                                $background={
                                    'linear-gradient(290deg,rgb(135, 183, 111) 0%, rgb(71, 113, 49) 100%)'
                                }
                                $rotate={180}
                            />
                        )}
                        {isInCategory3 && (
                            <S_Quarter
                                $background={
                                    'linear-gradient(290deg, #7A9AE1 -0.67%, #183982 133.56%)'
                                }
                                $rotate={270}
                            />
                        )}
                        {isInCategory4 && (
                            <S_Quarter
                                $background={
                                    'linear-gradient(310deg, #FBD760 14.03%, #F7CA39 70.68%)'
                                }
                                $rotate={0}
                            />
                        )}

                        <S_Line $rotate={0} />
                        <S_Line $rotate={90} />
                    </S_InnerCircle>
                </S_Circle>
            )}
        </S_Container>
    );
};

const S_Container = styled.div`
    background: #53589b;
    width: 125px;
    height: 70px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #193143;
    border: 1px solid #1d1d3a;
    box-shadow: 2px 2px 5px rgb(0 0 0 / 25%), inset 0px -2px 0px #282856,
        inset 0px 0px 25px 10px #212140;
`;

const S_Text = styled.div`
    font-family: ${EFonts.Regular};
    font-size: 15px;
    padding: 0 5px;
    margin: -3px 0 0 0;
    color: #dadaeb;
`;

const S_Circle = styled.div`
    width: 30px;
    height: 30px;
    display: block;
    position: absolute;
    bottom: -14px;
    left: 44.5px;
    border-radius: 50%;
`;

const S_InnerCircle = styled.div`
    width: 30px;
    height: 30px;
    display: block;
    border-radius: 50%;
    border: 1px solid #1d1d3a;
    overflow: hidden;
    position: relative;
    background: #333561;
`;

interface SQuarterProps {
    $background: string;
    $rotate: number;
}

const S_Quarter = styled.div.attrs<SQuarterProps>((props) => ({
    style: {
        background: props.$background,
        transform: `rotate(${props.$rotate}deg)`
    }
}))<SQuarterProps>`
    width: 14px;
    height: 14px;
    padding: 1px;
    bottom: 0;
    position: absolute;
    left: 0px;
    top: 0px;
    transform-origin: bottom right;
`;

interface SLine {
    $rotate: number;
}

const S_Line = styled.div.attrs<SLine>((props) => ({
    style: {
        transform: `rotate(${props.$rotate}deg)`
    }
}))<SLine>`
    transform-origin: center;
    left: -2px;
    right: -2px;
    top: 14px;
    position: absolute;
    height: 1px;
    background: #1d1d3a;
`;
